module.exports = __webpack_public_path__ + "media/music/piano_chords_6-79365bff.mp3";